const WEB_PROTOCOLS = new Set(['http:', 'https:']);

/**
 * Whether a link that apps or records give opens a web page, not a script
 * that would run in the dashboard
 * @param {unknown} url
 * @returns {boolean}
 */
export function isWebUrl(url) {
  if (typeof url !== 'string') {
    return false;
  }

  try {
    return WEB_PROTOCOLS.has(new URL(url, window.location.href).protocol);
  } catch {
    return false;
  }
}

/**
 * Open a link that apps or records give in another tab, with no hold on the
 * dashboard's window, when it is a web page
 * @param {string} url
 * @param {string} [target]
 * @returns {void}
 */
export function openWebUrl(url, target = '_blank') {
  if (isWebUrl(url)) {
    window.open(url, target, 'noopener,noreferrer');
  }
}
